<template>
  <qtm-content-block v-bind="$attrs" title="Requested Scope of Work">
    <div class="show-newlines" v-text="scopeOfWork" />
    <div v-if="instructions">
      <div class="mt-6 qtm-label text-secondary">
        Delivery Instructions
      </div>
      <div v-text="instructions" />
    </div>
  </qtm-content-block>
</template>

<script setup lang="ts">
export interface Props {
  instructions?: string
  scopeOfWork: string | null
}

defineProps<Props>()
</script>
